<a class="news-box" [class.shimmer-animate]="hasShimmer" href="javascript:void(0)">
    <div class="news-img" style="background:url('{{ item.image_thumbnail }}')">
    </div>
    <div class="news-info">
        <h2>{{ item.title  | translate}}</h2>
        <p [innerHTML]="item.description_short"></p>
    </div>
</a>
